import React from 'react';

import DataBlock from '../data-block/DataBlock';
import TopMessages from './components/top-messages/TopMessages';
import HeadToHead from './components/head-to-head/HeadToHead';
import CommonPage from '../../../components/common-page/CommonPage';

import scss from './MessageResponse.module.scss';

function MessageResponse() {
  return (
    <CommonPage className={scss.pageWrapper}>
      <DataBlock />
      <TopMessages />
      <HeadToHead />
    </CommonPage>
  );
}

export default MessageResponse;
